import { render, staticRenderFns } from "./MeetingSpeakerFix.vue?vue&type=template&id=654a849f&scoped=true"
import script from "./MeetingSpeakerFix.vue?vue&type=script&lang=js"
export * from "./MeetingSpeakerFix.vue?vue&type=script&lang=js"
import style0 from "./MeetingSpeakerFix.vue?vue&type=style&index=0&id=654a849f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654a849f",
  null
  
)

export default component.exports